// import 'devextreme/dist/css/dx.common.css';
// import './themes/generated/theme.base.css';
// import './themes/generated/theme.additional.css';
// import { createApp }  from "vue";
// import router from "./router";
// import themes from "devextreme/ui/themes";
// // import 'devextreme/dist/css/dx.light.css';
// // import 'devextreme/dist/css/dx.material.blue.light.css';
// import 'devextreme/dist/css/dx.material.blue.light.compact.css';

// import App from "./App";
// import appInfo from "./app-info";
// import { pinia } from './store';

// themes.initialized(() => {
//     const app = createApp(App);
//     app.use(router);
//     app.use(pinia);
//     app.config.globalProperties.$appInfo = appInfo;
//     app.mount('#app');
// });



// INI BARU



import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import { createApp }  from "vue";
import router from "./router";
import themes from "devextreme/ui/themes";
// import 'devextreme/dist/css/dx.light.css';
// import 'devextreme/dist/css/dx.material.blue.light.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';

import App from "./App";
import appInfo from "./app-info";
import { createPinia } from 'pinia';
import piniaPluginPersistedState from "pinia-plugin-persistedstate";

// themes.initialized(() => {
//     const pinia = createPinia();
//     pinia.use(piniaPluginPersistedState);
//     const app = createApp(App);
//     app.use(router);
//     app.use(pinia);
//     app.config.globalProperties.$appInfo = appInfo;
//     app.mount('#app');
// });//diubah karena activepinia tidak ada _s 

// Initialize Pinia
const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

// Initialize Vue app
const app = createApp(App);
app.use(router);
app.use(pinia);
app.config.globalProperties.$appInfo = appInfo;

// Mount the app only after theme initialization
themes.initialized(() => {
    app.mount('#app');
});

